import { useState } from 'react';
import { SaveAuthorizedIPsRequest } from 'vopay';
import { api } from '@/services/api.config';

export default function useUpdateAuthorizedIpAddresses() {
  const [updatingAuthorizedIps, setUpdatingAuthorizedIps] = useState(false);

  async function updateAuthorizedIps(params: SaveAuthorizedIPsRequest) {
    try {
      setUpdatingAuthorizedIps(true);
      const res = await api.postSaveAuthorizedIPs(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setUpdatingAuthorizedIps(false);
    }
  }

  return { updatingAuthorizedIps, updateAuthorizedIps };
}
